export default {
  Monday: 'Thứ 2',
  Tuesday: 'Thứ 3',
  Wednesday: 'Thứ 4',
  Thursday: 'Thứ 5',
  Friday: 'Thứ 6',
  Saturday: 'Thứ 7',
  Sunday: 'Chủ nhật',

  'By Day': 'Theo ngày',
  'By Week': 'Theo tuần',
  'By Month': 'Theo tháng',
  'By Year': 'Theo năm',

  // Filter Date
  Today: 'Hôm nay',
  'Last x days': '{{numbers}} ngày gần nhất',
  'Last 30 days': '30 ngày gần nhất',
  'This month': 'Tháng này',
  'This Month': 'Tháng này',
  'This quarter': 'Quý này',
  'All time': 'Tất cả',
  Custom: 'Tùy biến',

  millisecond: 'mili giây',
  second: 'giây',
  minute: 'phút',
  hour: 'giờ',
  day: 'ngày',
  week: 'tuần',
  month: 'tháng',
  quarter: 'quý',
  year: 'năm',
  date: 'ngày',
  milliseconds: 'mili giây',
  seconds: 'giây',
  minutes: 'phút',
  hours: 'giờ',
  days: 'ngày',
  weeks: 'tuần',
  months: 'tháng',
  quarters: 'quý',
  years: 'năm',
  dates: 'ngày',
};
